import * as angular from 'angular';

class SendAgainDialogService {
    constructor(
        private $q,
        private $translate,
        private $mdDialog,
        private $mdToast,
        private NewsletterDistributionService,
        private RecipientListsService
    ) {
        'ngInject';
    }

    private showSendAgainDialog(event, distribution, recipientLists) {
        const parent = angular.element(document.getElementsByClassName('mw-flexi-modal')[0]);
        return this.$mdDialog.show({
            template: `
                <md-dialog 
                    class="mw-mini-modal mw-mini-modal--wide mw-mini-modal--auto-height" 
                    aria-label="{{'newsletters__modal-title--send-again'|translate}}" 
                    layout="column"
                >
                    <mw-send-again-dialog 
                        class="mw-mini-modal-wrapper"
                        distribution="$ctrl.distribution"
                        recipient-lists="$ctrl.recipientLists"
                        layout="column" 
                        flex
                    >
                    </mw-send-again-dialog>
                </md-dialog>
            `,
            controller: () => {
            },
            bindToController: true,
            controllerAs: '$ctrl',
            locals: {
                distribution: distribution,
                recipientLists: recipientLists
            },
            targetEvent: event,
            parent: parent,
            multiple: true,
            autoWrap: false
        })
    }

    public sendAgain(event, distributionId) {
        this.$q.all([
            this.NewsletterDistributionService.getNewsletterDistribution(distributionId),
            this.RecipientListsService.getRecipientLists()
        ])
            .then((results) => {
                let [distribution, recipientLists] = results;
                this.showSendAgainDialog(event, distribution, recipientLists)
                    .then(
                        (model) => {
                            return this.NewsletterDistributionService.duplicateNewsletterDistribution(
                                distributionId, model.recipientList, model.subjectLine
                            )
                        },
                        () => 'cancelled'
                    )
                    .then(
                        // Send again success
                        (response) => {
                            if (response !== 'cancelled') {
                                this.$mdToast.show(
                                    this.$mdToast.mwSimpleTimed()
                                        .textContent(this.$translate.instant('newsletters__success-text--send-again'))
                                );
                                this.NewsletterDistributionService.load();
                            }
                        },
                        // Send again failed
                        () => {
                            this.$mdDialog.show(
                                this.$mdDialog.mwAlert()
                                    .title(this.$translate.instant('newsletters__error-title--not-resent'))
                                    .textContent(this.$translate.instant('newsletters__error-text--not-resent'))
                                    .ok(this.$translate.instant('OK'))
                                    .parent(angular.element(document.getElementsByClassName('mw-flexi-modal')[0]))
                            )
                        }
                    )
            })
    }
}

export default SendAgainDialogService;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/send-again-dialog/send-again-dialog.service.ts
 **/